import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Icon from "@material-ui/core/Icon";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CardContent from "@mui/joy/CardContent";
import MotorhomeIcon from "components/CustomIcons/Motorhome.js";
import PhoneIcon from "components/CustomIcons/Phone.js";
import EmailIcon from "components/CustomIcons/Email.js";
import ViewIcon from "components/CustomIcons/View.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import DownloadIcon from "components/CustomIcons/Download.js";
import StoreIcon from "components/CustomIcons/Store.js";
import Wizard from "components/Wizard/WizardRedesign.js";
import VehicleStep from "views/Clients/stepsClient/Vehicle.js";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from "@mui/lab";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import { Box } from "@mui/material";
import Step1 from "../Forms/WizardSteps/Step1";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import Add from "@material-ui/icons/Add";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// @material-ui/icons
import AllInbox from "@material-ui/icons/AllInbox";
import Apps from "@material-ui/icons/Apps";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import Place from "@material-ui/icons/Place";

import Email from "@material-ui/icons/Email";
import WhatsApp from "@material-ui/icons/WhatsApp";
import Phone from "@material-ui/icons/Phone";
import Download from "@material-ui/icons/CloudDownload";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import PaginatedPoliciesMobile from "components/Policies/PaginatedPoliciesMobile.js";
import PaginatedPoliciesAgent from "components/Policies/PaginatedPoliciesMobileAgentHome.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import Button from "components/CustomButtons/CustomButton";
import InputLabel from "@material-ui/core/InputLabel";
import Select, { SelectChangeEvent } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CustomModal from "components/CustomModal/Modal.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import PolicyCard from "@material-ui/icons/CardMembership";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomResource from "components/CustomResource/CustomResource";
import StepperComponent from "components/Stepper/StepperComponent";

import VehicleIcon from "components/CustomIcons/Vehicle.js";
import MotorcycleIcon from "components/CustomIcons/Motorcycle";
import ATVIcon from "components/CustomIcons/ATV";

import CustomCreditCard from "components/CustomCreditCard/CustomCreditCard";
import CreditCardList from "components/CreditCard/CreditCardList";

import {
  addCard,
  getCardsByClient,
  deleteCard,
} from "../Services/CreditCardService";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import extendedFormstyles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";

import {
  getOrdersByClient,
  getExpiringOrdersAgency,
  getDataGraph,
  getDataNews,
  getActiveOrdersByClient,
  getAgencyDataByClient,
  getQuotesByClient,
  getCustomerByToken,
  getPoliciesByAgent,
} from "views/Services/OrdersService";
import {
  formatCreditCardNumber,
  formatExpirationDate,
  sanatizeMessageHtml,
  validateField,
  generatePassword,
  checkIfIsKiosko,
  isAgent,
} from "components/Utils/utils.js";
import { Catalogs } from "views/Services/CatalogsService.js";
import {
  saveUserSettingsAPI,
  getZipCodeData,
} from "views/Services/ClientService.js";
import { getVehiclesList } from "views/Services/VehiclesService.js";

import environment from "../../environment/environment";
import { Assignment } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Grid } from "react-loader-spinner";
import { current } from "@reduxjs/toolkit";
import { update } from "@react-spring/web";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
const useExtFormStyles = makeStyles(extendedFormstyles);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const routeParams = useParams();
  const { id } = routeParams;
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  const classesExtForm = useExtFormStyles();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [ordersExpiring, setOrdersExpiring] = useState([]);
  const [orders, setOrders] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [data, setData] = useState(null);
  const [statesDl, setStatesDl] = React.useState([]);
  const [states, setStates] = React.useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [agencyData, setAgencyData] = useState(null);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [isOpenErrors, setIsOpenErrors] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [currentOrderId, setCurrentOrderId] = useState(0);
  const [currentName, setCurrentName] = useState("");
  const [csrEmail, setCsrEmail] = useState("");
  const [savingCard, setSavingCard] = useState(true);
  const [creditCardListModal, setCreditCardListModal] = useState(false);
  const [customerData, setCustomerData] = useState({
    additional_insured: "",
    additionalinsured: "",
    address: "",
    city: "",
    country_id: "",
    country: "",
    dl_country_id: "",
    dlcountry: "",
    dl_number: "",
    dlnumber: "",
    dl_state_id: "",
    dlstate: "",
    email: "",
    first_name: "",
    fname: "",
    clientnumber: "New Client",
    last_name: "",
    lname: "",
    middle_name: "",
    mname: "",
    phone: "",
    preferred_language: "en",
    state_id: "",
    state: "",
    valid_license: "1",
    validlicense: "1",
    zipcode: "",
  });
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [activeStep, setActiveStep] = useState(0);
  const [clientCards, setClientCards] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState(null);
  const [dataMonth, setDataMonth] = useState([]);
  const [dataYear, setDataYear] = useState([]);
  const [news, setNews] = useState([]);
  const [totalRowsPolicies, setTotalRowsPolicies] = useState(0);
  const [totalRowsOrders, setTotalRowsOrders] = useState(0);
  const [titleModal, setTitleModal] = useState("");
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const monthList = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };
  const [allPolicies, setAllPolicies] = useState(false);
  const rowsForPage = 10;

  const cardDataInitial = {
    "cnumber-card_string": "",
    "fname-card": "",
    "lname-card": "",
    "month-card": "",
    creditcardverificator_string: "",
    "year-card": "",
    expirationCard: "",
    focused: "",
    "id-card": "",
  };
  const [card, setCard] = React.useState(cardDataInitial);
  const [deleteCardModal, setDeleteCardModal] = React.useState(false);

  const cardStyleExpire = {
    border: "2px solid #F44336",
  };
  const cardStyleWarning = {
    border: "2px solid #FF9802",
  };
  const cardStyleSuccess = {
    border: "2px solid #4CAF50",
  };
  useEffect(() => {
    if (!isAgent) {
      history.push("/admin/home");
    }
    if (typeof id !== "undefined") {
      getCustomer(id);
    }
    getCatalogs();
  }, []);

  const getCustomer = async (customerId) => {
    if (localStorage.getItem("userToken") !== null) {
      const resultSubmit = await dispatch(
        getCustomerByToken({ customerId: customerId, profile: true })
      );
      getClientCards(resultSubmit.payload.data?.data_customer?.id);
      let customData = resultSubmit.payload.data?.data_customer;
      customData.clientnumber = resultSubmit.payload.data?.data_customer?.id;
      customData.fname = resultSubmit.payload.data?.data_customer?.first_name;
      customData.lname = resultSubmit.payload.data?.data_customer?.last_name;
      customData.mname = resultSubmit.payload.data?.data_customer?.middle_name;
      customData.validlicense =
        resultSubmit.payload.data?.data_customer?.valid_license;
      customData.dlnumber = resultSubmit.payload.data?.data_customer?.dl_number;
      customData.additionalinsured =
        resultSubmit.payload.data?.data_customer?.additional_insured;
      customData.dlstate =
        resultSubmit.payload.data?.data_customer?.dl_state_id;
      customData.dlcountry =
        resultSubmit.payload.data?.data_customer?.dl_country_id;
      customData.state = resultSubmit.payload.data?.data_customer?.state_id;
      customData.country = resultSubmit.payload.data?.data_customer?.country_id;
      setStatesDl(
        resultSubmit.payload.data?.catalogs.states.filter(
          (e) =>
            e.country_id ==
            resultSubmit.payload.data?.data_customer?.dl_country_id
        )
      );

      setStates(
        resultSubmit.payload.data?.catalogs.states.filter(
          (e) =>
            e.country_id == resultSubmit.payload.data?.data_customer?.country_id
        )
      );
      setCustomerData(customData);
      setTotalRowsPolicies(resultSubmit.payload.data.policies.length);
      setTotalRowsOrders(resultSubmit.payload.data.quotes.length);
      setPolicies(resultSubmit.payload.data.policies);
      setOrders(resultSubmit.payload.data.quotes);
      getVehicles(resultSubmit.payload.data?.data_customer?.id);
      setData(resultSubmit.payload.data);
    }
  };

  const getVehicles = async (customerId) => {
    const resultSubmit = await dispatch(
      getVehiclesList({ customerId: customerId })
    );
    if (resultSubmit.payload.result) {
      setVehicles(resultSubmit.payload.data);
    }
  };

  const getClientCards = async (clientId) => {
    setClientCards([]);
    setCard(cardDataInitial);
    const resultSubmit = await dispatch(
      getCardsByClient({ clientId: clientId })
    );

    if (resultSubmit.payload.result) {
      if (resultSubmit.payload.result) {
        if (resultSubmit.payload.data.length > 0) {
          setClientCards(resultSubmit.payload.data);
        } else {
          setClientCards([]);
        }
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
    setDeleteCardModal(false);
  };

  const getQuotes = async () => {
    const resultSubmit = await dispatch(getQuotesByClient({}));
    setQuotes(resultSubmit.payload.data);
  };
  const getOrders = async () => {
    const resultSubmit = await dispatch(getOrdersByClient());
    setOrdenes(resultSubmit.payload.data);
  };
  const getNewsHome = async () => {
    const resultSubmit = await dispatch(getDataNews({}));
    setNews(resultSubmit.payload.data);
  };
  const getDataGraphAgent = async (type) => {
    const resultSubmit = await dispatch(getDataGraph({ type: type }));
    setDataGraph(resultSubmit.payload, type);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    let updateCustomerData = { ...customerData };
    updateCustomerData[name] = value;

    if (name === "dl_country_id") {
      setStatesDl(data.catalogs.states.filter((e) => e.country_id == value));
      updateCustomerData["dlcountry"] = value;
    }
    if (name === "country_id") {
      setStates(data.catalogs.states.filter((e) => e.country_id == value));
      updateCustomerData["country"] = value;
    }
    if (name === "dl_state_id") {
      updateCustomerData["dlstate"] = value;
    }
    if (name === "state_id") {
      updateCustomerData["state"] = value;
    }
    if (name === "first_name") {
      updateCustomerData["fname"] = value;
    }
    if (name === "last_name") {
      updateCustomerData["lname"] = value;
    }
    if (name === "middle_name") {
      updateCustomerData["mname"] = value;
    }
    if (name === "valid_license") {
      updateCustomerData["validlicense"] = value;
    }
    if (name === "additional_insured") {
      updateCustomerData["additionalinsured"] = value;
    }
    if (name === "dl_number") {
      updateCustomerData["dlnumber"] = value;
    }
    setCustomerData(updateCustomerData);
  };

  const setDataGraph = (data, type) => {
    let monthList = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    };
    let currentTime = new Date();
    let monthCurrent = monthList[currentTime.getMonth() + 1];
    let yearCurrent = currentTime.getFullYear();
    let yearPrevious = yearCurrent - 1;

    const dataJson = [
      {
        name: monthCurrent + " " + yearPrevious,
        policyCount: data.totalPoliciesCountPrevious,
        netPremium: data.totalPoliciesAmountPrevious,
      },
      {
        name: monthCurrent + " " + yearCurrent,
        policyCount: data.totalPoliciesCountCurrent,
        netPremium: data.totalPoliciesAmountCurrent,
      },
    ];
    if (type == "year") {
      dataJson[0].name = yearPrevious;
      dataJson[1].name = yearCurrent;
    }
    type == "month" ? setDataMonth(dataJson) : setDataYear(dataJson);
  };
  const calculateExpirationText = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      let newDateExpiration = orderExpirationDate.split("-");
      const fechaActual = new Date();
      const fechaExpiracion = new Date(
        newDateExpiration[2] +
          "-" +
          newDateExpiration[0] +
          "-" +
          newDateExpiration[1]
      );
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias < 0) {
        return "Expired";
      } else {
        return "Active";
      }
    }
  };
  const calculateExpirationDays = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      return parseInt(diferenciaDias);
    }
    return 0;
  };

  const fillButtons = (order, type) => {
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() =>
              history.push(
                type == "policy"
                  ? `/guest/summary/${order.order_id}`
                  : `/guest/en/${order.id}`
              )
            }
            md={6}
          >
            <ViewIcon></ViewIcon>
          </GridItem>
          {type == "policy" && (
            <GridItem
              onClick={() => {
                window.open(`/admin/policyPdf/policy/${order.policy_nbr}`);
              }}
              md={6}
            >
              <DownloadIcon></DownloadIcon>
            </GridItem>
          )}
        </GridContainer>
      </>
    );
  };
  const completeQuote = (order) => {
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/guest/en/${order.id}`)}
            md={6}
          >
            <ViewIcon></ViewIcon>
          </GridItem>
        </GridContainer>
      </>
    );
  };

  const getMakeModelName = (order, type) => {
    return ["1", "5"].includes(order.vehicle_type_id)
      ? type == "make"
        ? order.make_name
        : order.model_name
      : type == "make"
      ? order.make
      : order.model;
  };

  const getCodeData = async (zipCode) => {
    let currentCustomerData = { ...customerData, zipcode: zipCode };
    if (validateField(zipCode)) {
      let dateToSend = { zipCode };
      const resultSubmit = await dispatch(getZipCodeData(dateToSend));
      if (resultSubmit.payload.result) {
        currentCustomerData.city = resultSubmit.payload.data.city_name;
        currentCustomerData.country_id = resultSubmit.payload.data.country_id;
        currentCustomerData.state_id = resultSubmit.payload.data.state_id;
        setStates(
          data.catalogs.states.filter(
            (e) => e.country_id == resultSubmit.payload.data.country_id
          )
        );
      }
      setCustomerData(currentCustomerData);
    } else {
      setCustomerData(currentCustomerData);
    }
  };

  const closeModal = () => {
    setIsOpenErrors(false);
    setCurrentName("");
    setCurrentOrderId(0);
    setCsrEmail("");
    setEmail("");
  };

  const getActivePolicies = (dataRows) => {
    let ordenesT = [];
    let daysLeft = 0;
    dataRows.forEach((policy, index) => {
      const status = calculateExpirationText(policy.expiration_date);
      const rowIndex = currentOffset + index + 1;
      ordenesT[rowIndex] = [
        policy.policy_nbr,
        {
          name: policy.dl_number,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: policy.last_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: policy.first_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: policy.year_model,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: policy.make,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: policy.model,
          className: isXs || isSm ? classes.displayNone : "",
        },
        policy.issue_date,
        {
          name: policy.effective_date,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: policy.expiration_date,
          className: isXs || isSm ? classes.displayNone : "",
        },
        <span
          className={`${classes.badge} ${
            status == "Active" ? classes.success : classes.danger
          }`}
        >
          {status}
        </span>,
        fillButtons(policy, "policy"),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                tableHead={[
                  t("policies.policyNumber"),
                  {
                    name: t("policies.dlNumber"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.lastName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.firstName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.year"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.make"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.model"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("policies.issueData"),
                  {
                    name: t("policies.effectiveData"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("policies.expirationDate"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("policies.status"),
                  t("policies.options"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
                rowsPerPage={10}
                totalRows={totalRowsPolicies}
              />

              <CustomModal
                title="Send Email"
                isOpen={isOpenErrors}
                onClose={closeModal}
                privacy={false}
                id={"emailModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <p style={{ color: "red" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanatizeMessageHtml(messageToast),
                        }}
                      ></div>
                    </p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={1}></GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step2.email")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "email",
                        id: "email",
                        value: email,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step4.csrInitials")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "csr",
                        id: "csr",
                        value: csrEmail,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="sendEmail"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            sendEmail();
                          }}
                          block
                        >
                          Send
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };
  const getActiveOrders = () => {
    let ordenesT = [];
    let daysLeft = 0;
    orders.forEach((order, index) => {
      const rowIndex = currentOffset + index + 1;
      ordenesT[rowIndex] = [
        order.producer_code,
        {
          name: order.created_date,
          className: isXs || isSm ? classes.displayNone : "",
        },
        order.folio,
        {
          name: order.last_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.first_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.year_model,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.make,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.model,
          className: isXs || isSm ? classes.displayNone : "",
        },
        fillButtons(order, "order"),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                tableHead={[
                  t("quotes.producer"),
                  {
                    name: t("quotes.dateSaved"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("quotes.quoteNumber"),
                  {
                    name: t("quotes.lastName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.firstName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.year"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.make"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.model"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("quotes.options"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
                rowsPerPage={10}
                totalRows={totalRowsOrders}
              />

              <CustomModal
                title="Send Email"
                isOpen={isOpenErrors}
                onClose={closeModal}
                privacy={false}
                id={"emailModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <p style={{ color: "red" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanatizeMessageHtml(messageToast),
                        }}
                      ></div>
                    </p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={1}></GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step2.email")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "email",
                        id: "email",
                        value: email,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step4.csrInitials")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "csr",
                        id: "csr",
                        value: csrEmail,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="sendEmail"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            sendEmail();
                          }}
                          block
                        >
                          Send
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };
  const focusWizard = () => {
    if (wizardRef.current) {
      setActiveStep(1);
      wizardRef.current.focusWizard(); // Llama al método del hijo
    }
  };

  const updateCustomer = async () => {
    let currentCustomerData = { ...customerData };
    currentCustomerData.agency = currentCustomerData.agent_id;
    currentCustomerData.typeOperation =
      currentCustomerData.clientnumber === "New Client"
        ? "insertCustomer"
        : "updateCustomer";
    if (currentCustomerData.clientnumber === "New Client") {
      currentCustomerData.password = generatePassword();
    }
    const resultSubmit = await dispatch(
      saveUserSettingsAPI(currentCustomerData)
    );
    let messageModal = resultSubmit.payload.message;
    const messageTitleModal =
      resultSubmit.payload.result === true ? "Success" : "Error";
    if (!resultSubmit.payload.result) {
      messageModal = "";
      resultSubmit.payload.data.errors.map((error, index) => {
        messageModal += `${error.Message}<br>`;
      });
    }
    setMessageToast(messageModal);
    setTitleModal(messageTitleModal);
    setModalSuccess(true);
    if (
      currentCustomerData.clientnumber === "New Client" &&
      resultSubmit.payload.result
    ) {
      setTimeout(() => {
        window.location.href = `/admin/client/${resultSubmit.payload.data.clientnumber}`;
      }, 4000);
    }
  };

  const getListQuotes = () => {
    let ordenesT = [];
    quotes.forEach((order) => {
      ordenesT.push([
        <>
          <span>{order.created_date || "N/A"}</span>
        </>,
        <b>
          {getMakeModelName(order, "make") || "N/A"}{" "}
          {getMakeModelName(order, "model") || "N/A"}
        </b>,
        completeQuote(order),
      ]);
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                style={{ width: "100%" }}
                tableHead={[
                  t("home.createdDate"),
                  t("home.vehicle"),
                  t("home.actions"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };
  const calculateExpiration = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias <= 5) {
        return cardStyleExpire;
      } else if (diferenciaDias >= 6 && diferenciaDias <= 15) {
        return cardStyleWarning;
      } else if (diferenciaDias >= 16) {
        return cardStyleSuccess;
      }
    }
    return cardStyleExpire;
  };
  const calculateExpirationColor = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      const fechaActual = new Date();
      const fechaExpiracion = new Date(orderExpirationDate);
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias <= 5) {
        return "rose";
      } else if (diferenciaDias >= 6 && diferenciaDias <= 15) {
        return "warning";
      } else if (diferenciaDias >= 16) {
        return "success";
      }
    }
    return cardStyleExpire;
  };
  const handleWhatsApp = () => {
    const url = `https://wa.me/9566863601`;
    window.open(url);
  };
  const handleOpenSMSApp = () => {
    window.location.href = `sms:9566863601`;
  };
  const handleMakePhoneCall = () => {
    window.location.href = `tel:9566863601`;
  };
  const classes = useStyles();

  // Hooks
  const [showActivePolicies, setActivePolicies] = React.useState(false);
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";
  const ActivePoliciesComponent = () => getActivePolicies();
  const getOrdenesActive = (orders) => {
    let ordenes = [];
    orders.forEach((order) => {
      let status = calculateExpirationText(order.expiration_date);
      if (status != "Expired") {
        ordenes.push(order);
      }
    });
    return ordenes;
  };
  const getOrdenesExpired = (orders) => {
    let ordenes = [];
    orders.forEach((order) => {
      let status = calculateExpirationText(order.expiration_date);
      if (status == "Expired") {
        ordenes.push(order);
      }
    });
    return ordenes;
  };

  const getCatalogs = async () => {
    const resultSubmit = await dispatch(Catalogs());
    if (resultSubmit.payload.result) {
      let dataPolicy = {
        data_customer: {
          id: "New Client",
          dl_number: "",
          dl_country_id: 0,
          valid_license: "",
          dl_state_id: 0,
          first_name: "",
          middle_name: "",
          last_name: "",
          address: "",
          zipcode: "",
          city: "",
          country_id: 0,
          state_id: 0,
          phone: "",
          email: "",
          additional_insured: "",
          agency_id: "",
        },
        coverages: {},
        selectedVehicle: {},
      };
      dataPolicy["catalogs"] = resultSubmit.payload.catalogs;
      if (dataPolicy["catalogs"].vehicle_types) {
        let vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "1"
        );
        vehicle &&
          (vehicle.icon = <VehicleIcon className={classes.optionInput} />);
        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "4"
        );
        vehicle &&
          (vehicle.icon = <MotorhomeIcon className={classes.optionInput} />);
        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "5"
        );
        vehicle &&
          (vehicle.icon = <MotorcycleIcon className={classes.optionInput} />);

        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "11"
        );
        vehicle && (vehicle.icon = <ATVIcon className={classes.optionInput} />);
        //vehicle = dataPolicy["catalogs"].vehicle_types.find(item => item.id === "10");
        //vehicle && (vehicle.icon = <TruckIcon className={classes.optionInput} />);
        dataPolicy["catalogs"].vehicle_types.splice(6, 1);
        dataPolicy["catalogs"].vehicle_types.splice(4, 1);
        dataPolicy["catalogs"].vehicle_types.splice(3, 1);
      }
      setData(dataPolicy);
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const handleChangeRadio = (value) => {
    let cardData = setCardData(clientCards, value);
    setSelectedValue(value);
    setCard(cardData);
    setCreditCardListModal(false);
  };

  const setCardData = (cards, cardId) => {
    let cardData = {};
    cards.forEach((element) => {
      if (element.id == cardId) {
        cardData["id-card"] = element.id;
        cardData["fname-card"] = element.first_name;
        cardData["lname-card"] = element.last_name;
        cardData["cnumber-card_string"] = element.number;
        cardData["type-ccard"] = element.card_type;
        let monthExpDate =
          typeof monthList[element.expiration_month] == "undefined"
            ? ""
            : monthList[element.expiration_month];
        const yearLastDigits = element.expiration_year.toString().slice(-2);
        cardData["expirationCard"] = `${monthExpDate}/${yearLastDigits}`;
        cardData["month-card"] = monthList[element.expiration_month];
        cardData["year-card"] = element.expiration_year;
        cardData["street-card"] = element.street;
        cardData["co-card"] = element.co;
        cardData["city-card"] = element.last_name;
        cardData["state-card"] = element.state;
        cardData["code-card"] = element.zipcode;
      }
    });
    return cardData;
  };

  const toggleCardListModal = () => {
    setCreditCardListModal((prevState) => !prevState);
  };

  const toggleDeleteCardModal = () => {
    setDeleteCardModal((prevState) => !prevState);
  };

  const inputHandlerCcv = ({ target }) => {
    let cardData = { ...card };
    let dataPolicy = { ...data };
    cardData["creditcardverificator_string"] = target.value;
    dataPolicy.card = cardData;
    setData(dataPolicy);
    setCard(cardData);
  };

  const handlerCardData = (cardId) => {
    if (typeof cardId != "undefined") {
      let cardData = setCardData(clientCards, cardId);
      setCard(cardData);
      toggleCardListModal(false);
      setSavingCard(true);
      setSelectedValue(null);
    }
  };

  const handlerSaveCard = (toSave) => {
    let cardDataSave = { ...card };
    setSelectedValue(null);
    setSaveCard(true);
    let validCard = checkDataCard(cardDataSave);
    if (validCard) {
      sendCardToSave(cardDataSave);
    }
  };

  const checkDataCard = (cardDataSave) => {
    let valid = true;
    cardDataSave["month-card"] =
      typeof cardDataSave["month-card"] == "undefined"
        ? ""
        : parseInt(cardDataSave["month-card"]);
    if (
      cardDataSave["cnumber-card_string"].replaceAll(" ", "") < 16 ||
      cardDataSave["cnumber-card_string"] == "" ||
      cardDataSave["cnumber-card_string"] == null ||
      typeof cardDataSave["month-card"] == "undefined" ||
      cardDataSave["month-card"] == null ||
      cardDataSave["fname-card"] == "" ||
      cardDataSave["fname-card"] == null ||
      typeof cardDataSave["fname-card"] == "undefined" ||
      cardDataSave["lname-card"] == "" ||
      cardDataSave["lname-card"] == null ||
      typeof cardDataSave["lname-card"] == "undefined" ||
      cardDataSave["type-ccard"] == "" ||
      cardDataSave["type-ccard"] == null ||
      typeof cardDataSave["type-ccard"] == "undefined" ||
      cardDataSave["month-card"] == "" ||
      cardDataSave["month-card"] == null ||
      cardDataSave["month-card"] > 12 ||
      cardDataSave["month-card"] == 0 ||
      cardDataSave["year-card"] == "" ||
      cardDataSave["year-card"] == null ||
      typeof cardDataSave["year-card"] == "undefined"
    ) {
      let messageToast = "";
      messageToast +=
        cardDataSave["month-card"] > 12 ||
        cardDataSave["month-card"] == 0 ||
        cardDataSave["month-card"] == ""
          ? "Please enter a valid month expiration date"
          : "";
      messageToast +=
        cardDataSave["year-card"] == ""
          ? "Please enter a valid year expiration date"
          : "";
      messageToast =
        messageToast == ""
          ? "Please check the information in your credit card"
          : messageToast;
      setMessageToast(messageToast);
      valid = false;
    }
    return valid;
  };

  const sendCardToSave = async (cardDataSave) => {
    let monthList = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    };
    let cardData = {
      "client-id-card": id,
      "id-card": cardDataSave["id-card"],
      "fname-card": cardDataSave["fname-card"],
      "lname-card": cardDataSave["lname-card"],
      "cnumber-card": cardDataSave["cnumber-card_string"].replaceAll(" ", ""),
      "type-ccard": cardDataSave["type-ccard"],
      "month-card": monthList[parseInt(cardDataSave["month-card"])],
      "year-card": "20" + cardDataSave["year-card"],
      "street-card": cardDataSave["street-card"],
      "co-card": cardDataSave["co-card"],
      "city-card": cardDataSave["city-card"],
      "state-card": cardDataSave["state-card"],
      "code-card": cardDataSave["code-card"],
    };
    const resultSubmit = await dispatch(addCard(cardData));

    if (resultSubmit.payload.result) {
      getClientCards(id);
      if (cardData["id-card"] > 0) {
        setCard(cardDataInitial);
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const inputHandler = ({ target }) => {
    let cardData = { ...card };
    let dataPolicy = { ...data };
    if (target.id === "cnumber-card_string") {
      let formatCreditCard = formatCreditCardNumber(target.value);
      target.value = formatCreditCard.value;
      cardData["type-ccard"] = formatCreditCard.cardTypeId;
    }
    if (target.id === "expirationCard") {
      target.value = formatExpirationDate(target.value);
      let value = target.value.split("/");
      cardData["month-card"] = value[0] ?? "";
      cardData["year-card"] = value[1] ?? "";
    }
    cardData[target.id] = target.value;
    dataPolicy.card = cardData;
    setData(dataPolicy);
    setCard(cardData);
  };

  const showAlertCard = (cardId) => {
    setIdCardToDelete(cardId);
    setDeleteCardModal(true);
  };

  const callBackCard = ({ issuer }, isValid) => {};

  const cancelSaveCard = () => {
    setSelectedValue(null);
    setSavingCard(false);
    setCard(cardDataInitial);
  };

  const stepClient = () => {
    return {
      stepName: t("clients.view.clientInfo"),
      color: "success",
      stepId: "active",
      stepComponent: (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={7}>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText={<span>{t("profile.clientNumber")}</span>}
                  id="clientnumber"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    disabled: true,
                    value: customerData?.clientnumber,
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={
                        <span>
                          {t("profile.driverLicense")} <small></small>
                        </span>
                      }
                      id="driverlicense"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: customerData?.dl_number,
                        name: "dl_number",
                        onChange: (event) => {
                          handleFormChange(event);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomSelect
                      labelText={t("profile.validDL")}
                      menuItems={[
                        {
                          value: "1",
                          label: t("common.yes"),
                        },
                        { value: "0", label: t("common.no") },
                      ]}
                      error={null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="valid_license"
                      value={customerData?.valid_license}
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "valid_license",
                        id: "valid_licenseStep2",
                        value: customerData?.valid_license,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomSelect
                      labelText={t("profile.dlCountry")}
                      menuItems={
                        data?.catalogs
                          ? data.catalogs.countries.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                          : []
                      }
                      error={null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="dl_country_id"
                      information={"Tooltip Text"}
                      value={customerData?.dl_country_id}
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "dl_country_id",
                        id: "dl_country_idStep1",
                        value: customerData?.dl_country_id,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomSelect
                      labelText={t("profile.dlState")}
                      menuItems={
                        statesDl
                          ? statesDl.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                          : []
                      }
                      error={null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="dl_state_id"
                      information={"Tooltip Text"}
                      value={customerData?.dl_state_id}
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "dl_state_id",
                        id: "dl_state_idStep1",
                        value: customerData?.dl_state_id,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText={
                        <span>
                          {t("profile.firstName")} <small></small>
                        </span>
                      }
                      id="firstname"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: customerData?.first_name,
                        name: "first_name",
                        onChange: (event) => {
                          handleFormChange(event);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText={<span> {t("profile.middleName")}</span>}
                      id="middlename"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: customerData?.middle_name,
                        name: "middle_name",
                        onChange: (event) => {
                          handleFormChange(event);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText={
                        <span>
                          {t("profile.lastName")} <small></small>
                        </span>
                      }
                      id="lastname"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: customerData?.last_name,
                        name: "last_name",
                        onChange: (event) => {
                          handleFormChange(event);
                        },
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText={
                    <span>
                      {t("profile.address")} <small></small>
                    </span>
                  }
                  id="address"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "address",
                    value: customerData?.address,
                    onChange: (event) => {
                      handleFormChange(event);
                    },
                  }}
                />
                <CustomInput
                  labelText={
                    <span>
                      {t("profile.zipCode")} <small></small>
                    </span>
                  }
                  id="zipcode"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "zipcode",
                    value: customerData?.zipcode,
                    onChange: (event) => {
                      handleFormChange(event);
                    },
                    onBlur: (event) => {
                      const { id, value } = event.target;
                      getCodeData(value);
                    },
                  }}
                />
                <CustomInput
                  labelText={
                    <span>
                      {t("profile.city")} <small></small>
                    </span>
                  }
                  id="city"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "city",
                    value: customerData?.city,
                    onChange: (event) => {
                      handleFormChange(event);
                    },
                  }}
                />
                <CustomSelect
                  labelText={t("profile.country")}
                  menuItems={
                    data?.catalogs
                      ? data.catalogs.countries.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="country_id"
                  information={"Tooltip Text"}
                  value={customerData?.country_id}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "country_id",
                    id: "country_idStep1",
                    value: customerData?.country_id,
                    onChange: handleFormChange,
                  }}
                />

                <CustomSelect
                  labelText={t("profile.state")}
                  menuItems={
                    states
                      ? states.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="state_id"
                  information={"Tooltip Text"}
                  value={customerData?.state_id}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "state_id",
                    id: "state_idStep1",
                    value: customerData?.state_id,
                    onChange: handleFormChange,
                  }}
                />

                <CustomInput
                  labelText={
                    <span>
                      {t("profile.phone")} <small></small>
                    </span>
                  }
                  id="phone"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "phone",
                    value: customerData?.phone,
                    onChange: (event) => {
                      handleFormChange(event);
                    },
                  }}
                />
                <CustomInput
                  labelText={
                    <span>
                      {t("profile.email")} <small></small>
                    </span>
                  }
                  id="email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "email",
                    value: customerData?.email,
                    onChange: (event) => {
                      handleFormChange(event);
                    },
                  }}
                />
                <CustomInput
                  labelText={<span>{t("profile.additionalInsured")}</span>}
                  id="additionalInsured"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "additional_insured",
                    value: customerData?.additional_insured,
                    onChange: handleFormChange,
                  }}
                />

                <CustomSelect
                  labelText={t("profile.preferredLanguage")}
                  menuItems={[
                    {
                      value: "",
                      label: t("step2.preferredLanguage"),
                    },
                    {
                      value: "en",
                      label: "English",
                    },
                    {
                      value: "es",
                      label: "Español",
                    },
                  ]}
                  error={null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="preferred_language"
                  information={"Tooltip Text"}
                  value={customerData?.preferred_language}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    required: true,
                    name: "preferred_language",
                    id: "preferred_languageStep1",
                    value: customerData?.preferred_language,
                    onChange: handleFormChange,
                  }}
                />
              </GridItem>
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
              <Button
                variant="green"
                style={{
                  width: "100%",
                  marginTop: "25px",
                }}
                onClick={() => {
                  updateCustomer();
                }}
              >
                {t("creditCard.saveButton")}
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      ),
    };
  };

  const stepsEditClient = () => {
    return id > 0
      ? [
          {
            stepName: t("clients.view.vehicles"),
            color: "success",
            stepId: "expired",
            stepComponent: <VehicleStep data={data} vehicles={vehicles}  />,
          },
          {
            stepName: t("clients.view.quotes"),
            color: "success",
            stepId: "saved",
            stepComponent: (
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    {orders && getActiveOrders(orders)}
                  </GridItem>
                </GridContainer>
              </div>
            ),
          },
          {
            stepName: t("clients.view.paymentInfo"),
            color: "success",
            stepId: "saved",
            stepComponent: (
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomCreditCard
                      inputHandler={inputHandler}
                      callBackCard={callBackCard}
                      cardData={card}
                      handlerSaveCard={handlerSaveCard}
                      handlerCardData={handlerCardData}
                      saveCard={saveCard}
                      messageToast={messageToast}
                      clientCards={clientCards}
                      handleChangeRadio={handleChangeRadio}
                      inputHandlerCcv={inputHandlerCcv}
                      creditCardListModal={creditCardListModal}
                      closeCardListModal={toggleCardListModal}
                      selectedValue={selectedValue}
                      savingCard={savingCard}
                      onlySave={true}
                      cancelSaveCard={cancelSaveCard}
                      clientView={true}
                    ></CustomCreditCard>

                    <CreditCardList
                      selectedValue={selectedValue}
                      creditCardListModal={creditCardListModal}
                      onClose={toggleCardListModal}
                      handleChangeRadio={handleChangeRadio}
                      inputHandler={inputHandlerCcv}
                      handlerCardData={handlerCardData}
                      handlerDeleteCard={showAlertCard}
                      clientCards={clientCards}
                    ></CreditCardList>
                  </GridItem>
                </GridContainer>
              </div>
            ),
          },
          {
            stepName: t("clients.view.policies"),
            color: "success",
            stepId: "saved",
            stepComponent: (
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    {policies && getActivePolicies(policies)}
                  </GridItem>
                </GridContainer>
              </div>
            ),
          },
        ]
      : [];
  };

  const homeCustomer = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <Wizard
                    ref={wizardRef}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={[stepClient(), ...stepsEditClient()]}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}></GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <Button
                        variant="info"
                        style={{
                          width: "100%",
                          marginTop: "25px",
                        }}
                        onClick={() => {
                          window.location.href = "/admin/clients";
                        }}
                      >
                        {t("clients.buttons.backToClients")}
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <Button
                        variant="white"
                        style={{
                          width: "100%",
                          marginTop: "25px",
                        }}
                        onClick={() => {
                          localStorage.removeItem("searchClients");
                          window.location.href = "/admin/clients";
                        }}
                      >
                        {t("clients.buttons.back")}
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
        <CustomModal
          title={titleModal}
          isOpen={modalSuccess}
          onClose={() => {
            setModalSuccess(false);
            setMessageToast("");
          }}
          privacy={false}
          id={"customerModal"}
        >
          <GridContainer>
            <GridItem xs={12}>
              <h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanatizeMessageHtml(messageToast),
                  }}
                ></div>
              </h4>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer>
                <GridItem xs={0} sm={0} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <Button
                    id="successButton"
                    type="submit"
                    variant="green"
                    onClick={() => {
                      setModalSuccess(false);
                      setMessageToast("");
                    }}
                    block
                  >
                    Ok
                  </Button>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </CustomModal>
      </div>
    );
  };

  return <>{homeCustomer()}</>;
}
